<template>

  <el-container class="home_container">
    <!--左侧菜单-->
    <NavItem :isCollapse="isCollapse" :xtname="loginUser.subsystem!=null?loginUser.subsystem.xtname||'':''"></NavItem>

    <el-container>
      <!--顶部-->
      <el-header >
        <!--      面包屑导航-->
        <div class="head-left">
          <span :class="isCollapse?'el-icon-s-unfold':'el-icon-s-fold'" style="font-size: 16px;margin-right: 10px;" @click="isCollapse=!isCollapse"></span>
          <Breadcrumb></Breadcrumb>
        </div>
        <div class="header-right">
          <div class="head-user">

            <span>{{loginUser.name}}</span>
          </div>
          <div>
            <el-tooltip content="安全退出" placement="top" :enterable="false">
              <el-button type="warning" size="mini" circle icon="el-icon-lock" @click="logOut"></el-button>
            </el-tooltip>
          </div>
        </div>

      </el-header>
      <!--中间内容区域-->
      <el-main class="home-el-main">
<!--        <router-view></router-view>-->

<!--        <el-tabs v-model="activePath" @tab-remove="removeTab" @tab-click="clickTab" >-->
<!--          &lt;!&ndash; :closable 首页不可关闭 &ndash;&gt;-->
<!--          <el-tab-pane-->
<!--            v-for="item in tabsValue"-->
<!--            :key="item.name"-->
<!--            :label="item.title"-->
<!--            :name="item.path"-->
<!--            :closable="tabsValue.length>1"-->
<!--          ><label slot="label">{{item.title}}</label>-->
<!--              &lt;!&ndash; keep-alive 保持路由状态 &ndash;&gt;-->
<!--&lt;!&ndash;              <keep-alive>&ndash;&gt;-->
<!--&lt;!&ndash;                <router-view ></router-view>&ndash;&gt;-->
<!--&lt;!&ndash;              </keep-alive>&ndash;&gt;-->
<!--          </el-tab-pane>-->
<!--        </el-tabs>-->
        <router-view ></router-view>
      </el-main>
      <!--底部-->
      <el-footer v-if="false">Footer</el-footer>
    </el-container>
    <!--密码重置-->
    <el-dialog
      title="密码重置"
      :visible.sync="dialogVisible" @close="closeDialog('ruleForm')" width="500px">
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="原密码" prop="ypass">
          <el-input type="password" v-model="ruleForm.ypass" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="pass">
          <el-input type="password" v-model="ruleForm.pass" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-container>



</template>

<script>
  import NavItem from "./NavItem";
  import Breadcrumb from "./Breadcrumb";
  // import store from '@/store'
  import {mapState} from 'vuex'
  import md5 from 'js-md5';
  export default {
    name: "Home",
    components: {NavItem, Breadcrumb},
    data() {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.ruleForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('checkPass');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        dialogVisible:false,
        isCollapse:false,
        ruleForm: {
          pass: '',
          checkPass: '',
          ypass: ''
        },
        rules: {
          ypass: [
            {required: true, message: '请输入原密码', trigger: ['blur','change'] }
          ],
          pass: [
            { validator: validatePass, trigger: ['blur','change']  }
          ],
          checkPass: [
            { validator: validatePass2, trigger:  ['blur','change'] }
          ]
        }
      }
    },
    methods: {
      logOut() {
        this.$store.dispatch("RESET_ALL",{});//重置所有store
        this.$router.push("/login")
      },
      //修改密码
      handleCommand(command){
        this.dialogVisible=true;
        //this.$message('click on item ' + command);
      },
      submitForm: function (formName) {
        var that = this;

        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            //console.log(that.ruleForm)
            var pdata={ypass:md5(that.ruleForm.ypass),pass:md5(that.ruleForm.pass)}
            let res=await that.$api.sys.userRpwd(pdata);
            // console.log(res)
            if (res.code!=0)return this.$message.error(res.data)
            this.$message.success(res.data);
            this.dialogVisible=false;
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      closeDialog(formName){
        this.$refs[formName].resetFields();
      },
      //移除选项卡
      removeTab(targetName){
        this.$store.dispatch('DEL_TAB',targetName)
      },
      //点击tab
      clickTab(event){
        // console.log('event>>',event)
        this.$store.dispatch('SET_ACTIVEPATH',event.name)
        // this.$router.push(event.name);
      }
    },
    //计算属性
    computed:{
      ...mapState({
        // activePath:state=>state.tabsValue.activePath,
        tabsValue:state=>state.tabsValue.tabsValue,
        loginUser:state=>state.loginUser.loginUser
      }),
      activePath:{
        get:function(){
          return this.$store.state.tabsValue.activePath;
        },
        set:function(newValue){
          // this.$store.dispatch('SET_ACTIVEPATH',event.name)
          this.$store.state.tabsValue.activePath = newValue;
          // console.log('newValue>>>',newValue)
          this.$router.push(newValue);
        }
      }
    },
    mounted() {
      // console.log('activePath>>>',this.$store.state.tabsValue.activePath)
      // console.log('activePath2::',activePath)
    }
  }
</script>

<style scoped lang="scss">

  .home_container {
    height: 100%;
  }
  /* 设置tabs内容面板100%填充父容器 */
  .tabs-panel-fit {
    margin: 0;
    padding: 0;
    /* background-color:#1F2D3D; */
    width: 100%;
    height: 100%;
    object-fit: fill;
  }

  /* 设置tabs内容面板的内边距为0 */
  .el-tabs--border-card>.el-tabs__content {
    padding: 0;
  }

  /* 设置tab的表框效果（重要） */
  .el-tabs.el-tabs--border-card {
    box-shadow: none;
    border-bottom: none;
    border: 0;
  }
  /*设置选项卡字体大小*/
  .el-tabs>.el-tabs__header .el-tabs__item>label {
    font-size: 12px!important;
  }
  /*设置选项卡中第一个首页选项卡不能关闭*/
  .el-tabs>.el-tabs__header .el-tabs__item:first-child>span {
    display: none;
  }

  .el-header {
    font-size: 12px;
    /*background:rgb(55,61,65);*/
    border-bottom: 1px #E4E7ED solid;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px!important;
    line-height: 50px;
    /*color: #ffffff;*/
    /*font-size: 22px;*/
    .head-left{
      display: flex;
      align-items: center;
    }
    .header-right{
      display: flex;
      .head-user{
        margin-right: 15px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/Home.vue